import React from 'react';
import Icon from '@/components/ui/AppIcon';
import Link from 'next/link';

interface RelatedService {
  title: string;
  description: string;
  icon: string;
  href: string;
}

interface RelatedServicesProps {
  services: RelatedService[];
}

const RelatedServices = ({ services }: RelatedServicesProps) => {
  return (
    <section className="py-20 bg-card">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-foreground mb-4">
            Gerelateerde diensten
          </h2>
          <p className="text-lg text-muted-foreground">
            Ontdek andere AI-oplossingen die uw bedrijf kunnen versterken
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <Link
              key={index}
              href={service.href}
              className="glassmorphic rounded-xl p-6 hover:shadow-premium transition-all duration-300 hover:-translate-y-1 group"
            >
              <div className="relative mb-4">
                <div className="absolute inset-0 bg-primary/20 rounded-lg blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="relative w-12 h-12 bg-gradient-to-br from-primary to-secondary rounded-lg flex items-center justify-center">
                  <Icon name={service.icon as any} size={24} className="text-background" />
                </div>
              </div>
              
              <h3 className="text-lg font-display font-bold text-foreground mb-2 group-hover:text-primary transition-colors duration-300">
                {service.title}
              </h3>
              
              <p className="text-sm text-muted-foreground leading-relaxed mb-4">
                {service.description}
              </p>
              
              <div className="flex items-center space-x-2 text-primary text-sm font-semibold">
                <span>Meer informatie</span>
                <Icon name="ArrowRightIcon" size={16} className="group-hover:translate-x-1 transition-transform duration-300" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedServices;